//Imports
import { Dimensions } from 'react-native';


//Constants
const SCREEN_WIDTH = Math.round(Dimensions.get('window').width);
const SCREEN_HEIGHT = Math.round(Dimensions.get('window').height);

const PRIVATE_CAR_20101 = 20101;
const PRIVATE_CAR_20102 = 20102;
const PRIVATE_CAR_20103 = 20103;
const BIKE_20201 = 20201;
const BIKE_20202 = 20202;
const CUMMERCIAL_20301 = 20301;
const CUMMERCIAL_20302 = 20302;

const EXTERNAL_DAMAGE = "External Damage";
const INTERNAL_DAMAGE = "Internal Damage"
const RC_BOOK = "RC Book"
const DRIVING_LICENSE = "Driving License"
const POLICE_FIR = "Police FIR"
const AADHAR_CARD = "Aadhar Card"
const PAN_CARD = "PAN Card"
const CNG = "CNG Kit"
const WEB_REQUEST = "isWebRequest";
const ANDROID_REQUEST = "isAndroidRequest";
const super_thank_you = "Super, thank you!";
const your_preins_apprvd = "Your pre-inspection is completed and the quote has been instantly approved."
const thank_you="Thank you!"
const preinsp_com_will_update = "The pre-inspection process is completed. We will update you soon with further details."
const DIRECT_PORTAL_AGENTCODE="1000651"

const VIDEO_TITLE = "Take a 360° video"
const VIDEO_URL = "https://d2h44aw7l5xdvz.cloudfront.net/videos/self-inspection-for-car.mp4"
const SELFI_IMAGE = "First click a selfie with your vehicle"
const ODOMETER = "Enter the vehicle, turn it on and take images of your odometer"

// ActivityTypeIDs
const ACTIVITY_TYPE_MOTOR_PRE_INSPECTION_SELF_SURVEY = 5;
const ACTIVITY_TYPE_MOTOR_2W_PRE_INSPECTION_SELF_SURVEY = 26;
const ACTIVITY_TYPE_MOTOR_CVOD_PRE_INSPECTION_SELF_SURVEY = 30;
const ACTIVITY_TYPE_MOTOR_4W_OD_NB_PRE_INSPECTION_SELF_SURVEY = 63;


/**
 * 
 * @param {*} activityTypeID 
 */
const isPI = (activityTypeID) => {
    if (activityTypeID > 0)
        return false
    else if (activityTypeID === ACTIVITY_TYPE_MOTOR_PRE_INSPECTION_SELF_SURVEY
        || activityTypeID === ACTIVITY_TYPE_MOTOR_2W_PRE_INSPECTION_SELF_SURVEY
        || activityTypeID === ACTIVITY_TYPE_MOTOR_CVOD_PRE_INSPECTION_SELF_SURVEY
        || activityTypeID === ACTIVITY_TYPE_MOTOR_4W_OD_NB_PRE_INSPECTION_SELF_SURVEY)
        return true
    else
        return false
}
export {
    SCREEN_WIDTH, SCREEN_HEIGHT, EXTERNAL_DAMAGE, INTERNAL_DAMAGE, RC_BOOK, DRIVING_LICENSE, POLICE_FIR, AADHAR_CARD, PAN_CARD, CNG, VIDEO_TITLE, SELFI_IMAGE, ODOMETER, VIDEO_URL, PRIVATE_CAR_20101,
    PRIVATE_CAR_20102, PRIVATE_CAR_20103, BIKE_20201, BIKE_20202, CUMMERCIAL_20301, CUMMERCIAL_20302, isPI, WEB_REQUEST, ANDROID_REQUEST, super_thank_you,
    your_preins_apprvd,thank_you,preinsp_com_will_update,DIRECT_PORTAL_AGENTCODE
};